import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/ui/components/AccordionComponent/AccordionComponent.tsx")